import angular from 'angular';
import '../../shared.module';
import template from './input.component.html';
import './input.component.scss';
import { nextFieldId } from '../../helpers/field-id.helper';

class InputController {
  $onInit() {
    this.fieldId = nextFieldId();
    this.ngModelCtrl.$render = () => {
      this.value = this.ngModelCtrl.$viewValue;
    };
  }

  get isPassword() {
    return this.type === 'password';
  }

  get inputType() {
    if (this.isPassword && this.revealed) return 'text';
    return this.type || 'text';
  }

  toggleReveal() {
    this.revealed = !this.revealed;
  }

  handleChange() {
    this.ngModelCtrl.$setViewValue(this.value);
  }
}

angular.module('app.shared').component('cpInput', {
  bindings: {
    label: '@',
    type: '@',
    placeholder: '@',
    icon: '@',
    hint: '@',
    error: '@',
    disabled: '<'
  },
  require: { ngModelCtrl: 'ngModel' },
  controller: InputController,
  controllerAs: 'vm',
  template
});
